// Round TA-4 — one place to derive the static-asset host (profile images,
// uploads) from REACT_APP_API_URL instead of hardcoding the server name in
// every file. The historical host stays as the fallback so environments
// without the env var behave exactly as before.
const assetBase = (process.env.REACT_APP_API_URL || "http://www.sswhite.systems:7168/api/")
    .replace(/\/api\/?$/, "");

export const assetUrl = (path) =>
    `${assetBase}${path || "/uploads/user-dummy-img.jpg"}`;

export default assetBase;
